var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.002,
    height: 15.636,
    viewBox: "0 0 15.002 15.636",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3847",
    "data-name": "Group 3847",
    transform: "translate(-16996 2864)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3846",
    "data-name": "Group 3846",
    transform: "translate(36.301 -586)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_edit_3749814",
    transform: "translate(16959.699 -2278)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3845",
    "data-name": "Group 3845",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4778",
    "data-name": "Path 4778",
    d: "M33.55,16.035l-.366,2.578a.58.58,0,0,0,.146.457.526.526,0,0,0,.384.165h.073l2.578-.366a1.48,1.48,0,0,0,.841-.421l5.156-5.156.841-.823a1.671,1.671,0,0,0,.494-1.207,1.716,1.716,0,0,0-.494-1.207l-.823-.823a1.711,1.711,0,0,0-2.432,0l-.823.841-5.156,5.12A1.376,1.376,0,0,0,33.55,16.035Zm7.186-6.052a.629.629,0,0,1,.878,0l.823.823a.618.618,0,0,1,0,.878h0L42,12.121l-1.7-1.7Zm-6.107,6.2a.5.5,0,0,1,.11-.219l4.772-4.772.859.859.859.859L36.439,17.68a.417.417,0,0,1-.219.11l-1.865.256Z",
    transform: "translate(-28.791 -8.592)",
    fill: "#9b9eac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4779",
    "data-name": "Path 4779",
    d: "M23.172,13.054a.536.536,0,0,0-.545.545v7.763a1.179,1.179,0,0,1-1.182,1.182H10.973a1.179,1.179,0,0,1-1.182-1.182V10.273a1.179,1.179,0,0,1,1.182-1.182H18.1A.545.545,0,1,0,18.1,8H10.973A2.273,2.273,0,0,0,8.7,10.273v11.09a2.273,2.273,0,0,0,2.273,2.273H21.427A2.273,2.273,0,0,0,23.7,21.363V13.6A.532.532,0,0,0,23.172,13.054Z",
    transform: "translate(-8.7 -8)",
    fill: "#9b9eac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4780",
    "data-name": "Path 4780",
    d: "M21.949,72a.549.549,0,0,0,0,1.1h5.266a.549.549,0,0,0,0-1.1Z",
    transform: "translate(-19.101 -60.369)",
    fill: "#9b9eac"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.8e5d9a699c2d2a34bc79ea29f21e05ff.svg";
export { ForwardRef as ReactComponent };